@import '@alfalab/core-components-vars/src/index.css';
@import '../../vars.css';

.button.button {
    @mixin action_component_secondary;

    border-radius: var(--border-radius-circle);
    padding: var(--gap-0);
    min-width: var(--pass-code-button-min-width);
    width: var(--pass-code-button-width);
    height: var(--pass-code-button-height);

    text-align: center;

    & > span {
        vertical-align: middle;

        & > * {
            vertical-align: middle;
        }
    }
}

.secondary.secondary,
.button.button {
    color: var(--color-light-text-primary);
    background-color: var(--color-light-transparent-default);

    @media (hover: hover) {
        &:hover {
            background-color: var(--color-light-transparent-default-hover);
        }
    }

    &:active {
        background-color: var(--color-light-transparent-default-press);
    }
}
